import React, { useState, useEffect } from 'react'
import { shallowEqual, useSelector } from "react-redux";
import { Card, CardBody, CardHeader } from '../../../../../_metronic/_partials/controls'
import {
	Button,
	Checkbox,
	FormControlLabel,
	MuiThemeProvider,
	TextField,
	createMuiTheme
} from '@material-ui/core'
import { useSkeleton } from '../../../../hooks/useSkeleton'
import ConfirmDialog from "../../../../components/dialogs/ConfirmDialog";
import { alertError } from '../../../../../utils/logger';
import { changes, setChanges } from '../../../../../utils/globals';
import { Col, Row } from 'react-bootstrap';
import Editor from '../../../../components/editor/Editor';

// Create theme for delete button (red)
const theme = createMuiTheme({
	palette: {
		secondary: {
			main: "#F64E60",
		},
	},
});

export default function EditPatientResponseForm(props) {
	const { data, setOpen, onDelete, onSave } = props;
	const [form, setForm] = useState(null);
	const [openConfirmDialog, setOpenConfirmDialog] = useState(0);
	const [refresh, setRefresh] = useState(false);

	const { isLoading: isLoadingData, disableLoading: disableLoadingData, ContentSkeleton } = useSkeleton()
	const user = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);

	// const [changes, setChanges] = useState(-2);
	useEffect(() => setChanges(-2), []);
	useEffect(() => {
		if (changes <= 0) setChanges(changes+1);
	}, [form])

	useEffect(() => {
		if (data) {

			function sortByNumber(a, b) {
				if (a < b) return -1;
				if (b < a) return 1;
				return 0;
			}

			let newForm = {...data};
			newForm.answers.sort(sortByNumber);
			setForm(newForm);
			disableLoadingData();
		} else setOpen(false);
	}, [data, disableLoadingData])

	useEffect(() => {
		setRefresh(false);
	}, [refresh]);
	
	const handleChange = (element, value) => {
		setForm({ ...form, [element]: value })
	}

	const AnswerItem = ({answer}) => {
		const { number, question, answer: ans} = answer;

		return (
			<>

			<Row>
				<Col>
					<TextField
						key={number}
						id={number}
						label={`Question ${number}`}
						inputProps={{ readOnly: true }}
						value={question}
						margin="normal"
						variant="standard"
						type="text"
						className='readonly'
						multiline
					/>
				</Col>
				<Col>
					<TextField
						key={ans}
						id={ans}
						label="Answer"
						inputProps={{ readOnly: true }}
						value={ans}
						margin="normal"
						variant="standard"
						type="text"
						className='readonly'
						multiline
					/>
				</Col>
			</Row>
			</>
		)
	}

	const RenderAnswers = () => {
		return (
			<>
				{ form?.answers && form?.answers?.length > 0 ? (
					<>
						{form.answers.map((x) => (
							<AnswerItem answer={x}/>
						))}
					</>
				) : (
					<>
						<h4>There is no answers.</h4>
					</>
				)}
			</>
		)
	}

	if (isLoadingData)
		return <ContentSkeleton />
	else return (
		<>
		<Card>
		<CardHeader title={"Form response"}>
			<div className='mt-5'>
			<Button
				onClick={() => {
				if (changes > 0) setOpenConfirmDialog(1);
				else setOpen(false);
				}}
				variant="outlined"
				style={{ marginRight: '20px' }}>
				Back
			</Button>
			<Button
				onClick={async () => {
					setOpenConfirmDialog(3);
				}}
				variant="outlined"
				color="primary"
				style={{ marginRight: '20px' }}>
				Save form
			</Button>
			<ConfirmDialog
				title={
				"Are you sure you want to go back? You will lose all your changes."
				}
				open={openConfirmDialog === 1}
				setOpen={setOpenConfirmDialog}
				onConfirm={async () => {setOpen(false);}}
			/>
			<ConfirmDialog
				title={
				"Are you sure you want to send the response to the user?"
				}
				open={openConfirmDialog === 3}
				setOpen={setOpenConfirmDialog}
				onConfirm={async () => {
					const res = await onSave(form);
					if (res) setOpen(false);
				}}
			/>
				{user?.role.includes("admin") && (
					<>
					<MuiThemeProvider theme={theme}>
						<Button
						onClick={() => setOpenConfirmDialog(2)}
						variant="outlined"
						color="secondary"
						style={{ marginRight: "20px" }}
						>
						Delete form
						</Button>
						<div
						style={{
							display: "flex",
							flexDirection: "row",
							marginLeft: "auto",
						}}
						></div>
					</MuiThemeProvider>

					<ConfirmDialog
						title={
						"Are you sure you want to delete this form?"
						}
						open={openConfirmDialog === 2}
						setOpen={setOpenConfirmDialog}
						onConfirm={async () => {
							const res = await onDelete(form);
							if (res) setOpen(false);
						}}
					/>
					</>
				)}
			</div>
		</CardHeader>
			<CardBody>

				{ form && (
					<Editor
						body={form?.nutritionistResponse || ""}
						setBody={(new_body) => {handleChange("nutritionistResponse", new_body)}}
						className="max-height"
						placeholder={"Your response..."}
						name="Your response"
					/>
				)}
				<br />

				<RenderAnswers />
			</CardBody>
		</Card>
		</>
	);
}
